export const theme = {
  colors: {
    primary: "#6130B5",
    primaryLight: "#efebff",
    secondary: "#EBEDF0", //EBEBEB
    lightGrey: "#EBEDF0",
    darkGrey: "#979A9D",
    borderColor: "#D4D8DB",
    success: "#C4F0B9",
    darkGreen: "#308f19",
    mediumGreen: "#86D074",
    warning: "#F9EB9C",
    error: "#FFAAAA",
    danger: "#F32929",
    info: "#C2DCFD",
    mediumBlue: "#3d7dcf",
    darkBlue: "#13498d",
    navLink: "#36353C",
    background: "#FBFBFF",
    text: "#000000",
    textSecondary: "#4D4D4D",
    placeholder: "#93969a",
    white: "#ffffff",
    cardColor: "#c6c9e8",
  },
  spacing: {
    small: "10px",
    medium: "20px",
    large: "40px",
    max: "60px",
  },
  padding: {
    small: "10px",
    medium: "20px",
    large: "40px",
    button: "10px 20px",
    body: "20px",
    container: "30px",
  },
  shadow: {
    small: "0 0 6px rgba(0, 0, 0, 0.05)",
    medium: "0 0 6px rgba(0, 0, 0, 0.1)",
    large: "0 0 6px rgba(0, 0, 0, 0.12)",
  },
  fonts: {
    body: "'Nunito', sans-serif",
    heading: "'Nunito', sans-serif",
  },
  borderRadius: {
    small: "6px",
    medium: "20px",
    large: "30px",
  },
  typography: {
    h1: {
      fontSize: "2rem",
      fontWeight: 700,
    },
    h2: {
      fontSize: "1.3rem",
      fontWeight: 600,
    },
    h3: {
      fontSize: "1.2rem",
      fontWeight: 600,
    },
    body: {
      fontSize: "0.9rem",
      fontWeight: 400,
    },
    medium: {
      fontSize: "1rem",
      fontWeight: 500,
    },
    small: {
      fontSize: "0.75rem",
      fontWeight: 400,
    },
  },
};

export type Theme = typeof theme;
